import { NgModule } from '@angular/core';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { SharedModule } from '../../../shared/shared.module';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { SignatureCertComponent } from './signature-cert/signature-cert.component';
import { IvSignProComponent } from './ivsignpro/ivsignpro.component';
import { RedirectMfsComponent } from './ivsignpro/redirect-mfs/redirect-mfs.component';

@NgModule({
  declarations: [SignaturePadComponent, SignatureCertComponent, IvSignProComponent, RedirectMfsComponent],
  imports: [
    SharedModule,
    NgxQRCodeModule,
  ],
  exports: [SignaturePadComponent, SignatureCertComponent, IvSignProComponent],
})
export class SignatureModule {}
